export type Advantage = {
  title: string;
  description: string;
  image: string;
  order: number;
};

export const ADVANTAGES: Advantage[] = [
  {
    title: 'Full Truckload (FTL) Services',
    description:
      'Dedicated trucks for large shipments, ensuring fast and direct delivery.',
    image: '/images/full-truckload.png',
    order: 1,
  },
  {
    title: 'PTL (Partial Truckload) Services',
    description:
      'Cost-effective solution for medium-sized shipments that don’t require a full truck but need faster transit than LTL.',
    image: '/images/ptl-services.png',
    order: 2,
  },
  {
    title: 'LTL (Less-Than-Truckload) Shipping',
    description:
      'Flexible and affordable shipping for smaller loads, with shared trailer space and regular departures.',
    image: '/images/ltl-shipping.png',
    order: 3,
  },
  {
    title: 'Intermodal Transportation',
    description:
      'Seamless freight movement using combined rail and truck transport to reduce cost and emissions.',
    image: '/images/intermodal-transportation.png',
    order: 4,
  },
  {
    title: 'Specialized and Customized Solutions',
    description:
      'Expert handling of oversized, overweight, and delicate shipments.',
    image: '/images/specialized-solutions.png',
    order: 5,
  },
  {
    title: 'Expedited Shipping',
    description:
      '24/7 availability for urgent deliveries with priority handling and optimized routes.',
    image: '/images/expedited-shipping.png',
    order: 6,
  },
];
